import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between px-4 py-4 flex-items lg:px-6 lg:py-5 bg-primary-600" }
const _hoisted_2 = { class: "flex items-center 2xl:hidden" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center ml-1.5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "object-contain w-7 h-7",
    src: "assets/logo-picture.png",
    alt: "logo"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "text-white ml-2.5 mr-4 font-semibold text-xs" }, [
    /*#__PURE__*/_createTextVNode("Web-based WCPMIS "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Administrative Data")
  ])
], -1)
const _hoisted_4 = { class: "items-center hidden 2xl:flex" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "object-contain w-7 h-7",
    src: "assets/logo-picture.png",
    alt: "logo"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "text-white ml-2.5 mr-4 font-semibold text-xs" }, [
    /*#__PURE__*/_createTextVNode("Web-based WCPMIS "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Administrative Data")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "w-px h-5 mr-3 border-r border-white opacity-30" })
], -1)
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "mr-4" }
const _hoisted_8 = { class: "w-8 h-8 bg-[#D2851B] rounded-full object-cover text-center relative" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "notif-badge border border-primary-600 w-3 h-3 rounded-full bg-cstmgreen absolute right-[2px] bottom-[-3px]" }, null, -1)
const _hoisted_11 = { class: "flex-col flex-1 hidden min-w-0 text-left lg:flex" }
const _hoisted_12 = { class: "text-xs font-semibold text-white truncate" }
const _hoisted_13 = { class: "flex items-center px-3 py-3 text-gray-600 transition bg-white cursor-pointer hover:bg-primary-300" }
const _hoisted_14 = {
  href: "/profile",
  class: "relative flex"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, " Profile ", -1)
const _hoisted_16 = { class: "flex items-center px-3 py-3 text-gray-600 transition bg-white cursor-pointer hover:bg-primary-300" }
const _hoisted_17 = {
  href: "/notification",
  class: "relative flex"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, " Notifications ", -1)
const _hoisted_19 = {
  key: 0,
  class: "notif-badge border border-white w-3 h-3 rounded-full bg-primary-600 absolute left-[13px] top-[2px]"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, " Logout ", -1)
const _hoisted_21 = { class: "text-sm font-semibold" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0" }, null, -1)
const _hoisted_23 = { class: "fixed inset-0 overflow-hidden" }
const _hoisted_24 = { class: "absolute inset-0 overflow-hidden bg-[#0000014d]" }
const _hoisted_25 = { class: "fixed inset-y-0 left-0 flex max-w-full pr-10 pointer-events-none" }
const _hoisted_26 = { class: "flex flex-col h-full py-2 overflow-y-scroll shadow-xl bg-primary-600" }
const _hoisted_27 = { class: "relative flex-1 pl-6 pr-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/CPN-Logo-white.png",
  alt: "logo",
  class: "w-[200px] h-[92px] object-contain mb-10"
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-200 text-xs font-medium mb-2.5" }, "MAIN MENU", -1)
const _hoisted_30 = { class: "flex flex-col" }

import http from "@/axios";

import { Network } from '@capacitor/network';

import { ref, onMounted, computed, watch, onBeforeMount } from 'vue';
import { IonHeader } from "@ionic/vue";
import { ChevronDownIcon, ChevronLeftIcon, Bars3Icon, ArrowPathIcon, XMarkIcon } from "@heroicons/vue/24/solid";
import { Menu, MenuButton, MenuItems, MenuItem, Dialog, DialogPanel, TransitionChild, TransitionRoot, } from "@headlessui/vue";
import { useRouter } from "vue-router";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import NavigationLink from './Components/NavigationLink.vue';
import DraftLink from './Components/DraftLink.vue';
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import SyncSplashModal from '@/components/modals/SyncSplashModal.vue';
import { logout } from "@/classes/AuthService";
import Notifications from "@/classes/Notifications";
import Storage from "@/helpers/storage";
import NewPinModal from '@/components/modals/NewPinModal.vue';
import LockUserModal from '@/components/modals/LockUserModal.vue';
import DraftService from "@/classes/Drafts/DraftService";
import { useNetworkStore } from "@/store/network";
import { useDraftLogger } from "@/store/draftlogger"
// import DB from "@/classes/Databases/Crud";// @TODO for removal soon
import NavProfileIcon from "@/components/icons/navProfileIcon.vue";
import NavNotificationIcon from "@/components/icons/navNotificationIcon.vue";
import NavLogoutIcon from "@/components/icons/navLogoutIcon.vue";
import ArrowLeftIcon from "@/components/icons/arrowLeftIcon.vue";
import SecurityFeatureModal from "@/components/modals/SecurityFeatureModal.vue"
import { useSecurityFeature } from "@/store/securityFeature";


export default /*#__PURE__*/_defineComponent({
  __name: 'TopNavigation',
  props: {
	hasBack: {
		type: Boolean,
		default: false,
	},
	backLink: {
		type: String,
		default: null,
	},
	hasBackClass: {
		type: String,
		default: "flex justify-between items-center",
	},
	backTitle: {
		type: String,
		default: "Back",
	},
	pageTitle: {
		type: String,
		default: null
	}
},
  setup(__props) {

const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);
const isActualNetworkAvailable = computed(() => networkStore.isActualNetworkAvailable);
const draft = useDraftLogger();
const hasNewDraft = computed<boolean>(() => draft.hasDraft);
const hasNotifications = ref<boolean>(false);
const online = ref<boolean>(true)
const showConfirmation = ref<boolean>(false)
const draftCount = ref<number>(0);
const router = useRouter();
const currentRouteName = router.currentRoute.value.name;
const storage = new Storage();
const user = computed(() => JSON.parse(storage.get('user')));
const showMenu = ref<boolean>(false);
const showSecurityFeature = ref<boolean>(false);

const props = __props;

const redirect = (): void => {
	return router.replace(props.backLink);
};

const checkNotifications = (): void => {
	Notifications.hasNotification()
		.then(({ data }) => {
			hasNotifications.value = data.success;
		})
		.catch((error) => (console.log(error)))
}

const logoutUser = (): void => {
	showConfirmation.value = true;
}

Network.addListener('networkStatusChange', status => {
	// console.log('Network status changeds', status);
	
	online.value = status.connected
});


const logCurrentNetworkStatus = async ():Promise<any> => {
	const status = await Network.getStatus();

	online.value = status.connected	

	// if (status.connected) {
	// 	DraftService.sync()
	// }
};

const renderDraftLogs = async (): Promise<any> => {
    // const patients = await dbPatient.select('SELECT * FROM patients WHERE is_sync=false AND (is_created_offline=true OR is_updated_offline=true OR is_deleted_offline=true)');
    // const cases = await dbCases.select('SELECT * FROM cases WHERE is_sync=false AND (is_created_offline=true OR is_updated_offline=true OR is_deleted_offline=true)');
    // const perpetrators = await dbPerpetrators.select('SELECT * FROM perpetrators WHERE is_sync=false AND (is_created_offline=true OR is_updated_offline=true OR is_deleted_offline=true)');
    // const casePerpetrators = await dbCasePerpetrators.select('SELECT * FROM case_perpetrators WHERE is_sync=false AND (is_created_offline=true OR is_updated_offline=true OR is_deleted_offline=true)');
    // const caseGuardians = await dbGuardians.select('SELECT * FROM case_guardians WHERE is_sync=false AND (is_created_offline=true OR is_updated_offline=true OR is_deleted_offline=true)');
    // const caseInformant = await dbCompanions.select('SELECT * FROM case_companions WHERE is_sync=false AND (is_created_offline=true OR is_updated_offline=true OR is_deleted_offline=true)');
    // const casePatienAddress = await dbPatientAddress.select('SELECT * FROM case_patient_addresses WHERE is_sync=false AND (is_created_offline=true OR is_updated_offline=true OR is_deleted_offline=true)');
    // const interventions = await dbIntervention.select('SELECT * FROM intervention_data WHERE is_sync=false AND (is_created_offline=true OR is_updated_offline=true OR is_deleted_offline=true)');
	
    // draftCount.value = patients.length + cases.length + perpetrators.length + casePerpetrators.length + caseGuardians.length + caseInformant.length + casePatienAddress.length + interventions.length;
    // draft.count = draftCount.value;
}

const triggerLogout = (): void => {
	logout()
}

const redirectOffline = () => {
    if (!isNetworkAvailable.value) {
        if (location.href.match('/dashboard') || 
            location.href.match('/personnel') || 
            location.href.match('/office') ||
            location.href.match('/reports') ||
            location.href.match('/settings') ||
            location.href.match('/patient-logs')) {
                router.replace('/patient/search');
        }
    }
}

const renderDraftCount = () => {
    draft.count = localStorage.getItem('cpn-offline-draft-count') || 0;
}

// watch(
// 	() => hasNewDraft.value,
// 	(val) => {
// 		console.log("Watcher - Draft: " + val);
// 		if (val) {
//             draftCount.value = draft.count;
// 			// renderDraftLogs()
// 		}
// 	}
// );

onMounted(() => {
	if (isNetworkAvailable.value) {
		checkNotifications()
	}
	renderDraftLogs();
	logCurrentNetworkStatus();
    redirectOffline();
    renderDraftCount();
});

onBeforeMount(() => {
    const status = eval(storage.get('enable-security-feature'));
    if (status && isActualNetworkAvailable.value) {
        useSecurityFeature().isActivated = true;
        // showSecurityFeature.value = true;
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonHeader), { class: "w-full frm-header" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(ButtonComponent, {
            size: "small",
            customClass: "bg-transparent py-0 px-0",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showMenu.value = true))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Bars3Icon), {
                class: "w-6 h-6 text-white",
                "aria-hidden": "true"
              })
            ]),
            _: 1
          }),
          _hoisted_3
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(NavigationLink, { status: online.value }, null, 8, ["status"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(DraftLink, {
              count: _unref(draft).count
            }, null, 8, ["count"])
          ]),
          _createVNode(_unref(Menu), {
            as: "div",
            class: "relative inline-block text-left"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_unref(MenuButton), { class: "flex items-center min-w-0 space-x-3" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("img", {
                        class: "text-sm font-bold leading-8 text-white rounded-full",
                        src: user.value.profile_photo_url
                      }, null, 8, _hoisted_9),
                      _hoisted_10
                    ]),
                    _createElementVNode("span", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(user.value.first_name) + " " + _toDisplayString(user.value.last_name), 1)
                    ]),
                    (isNetworkAvailable.value)
                      ? (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
                          key: 0,
                          class: "hidden w-5 h-5 ml-2 text-white lg:inline-block",
                          "aria-hidden": "true"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              (isNetworkAvailable.value)
                ? (_openBlock(), _createBlock(_Transition, {
                    key: 0,
                    "enter-active-class": "transition duration-100 ease-out",
                    "enter-from-class": "transform scale-95 opacity-0",
                    "enter-to-class": "transform scale-100 opacity-100",
                    "leave-active-class": "transition duration-75 ease-in",
                    "leave-from-class": "transform scale-100 opacity-100",
                    "leave-to-class": "transform scale-95 opacity-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(MenuItems), { class: "absolute right-0 z-[1] mt-2 origin-top-right min-w-[175px] rounded border border-gray-200 bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(MenuItem), null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("a", _hoisted_14, [
                                  _createVNode(NavProfileIcon, { class: "w-6 h-6 object-contain inline-block mr-2.5" }),
                                  _hoisted_15
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(MenuItem), null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("a", _hoisted_17, [
                                  _createVNode(NavNotificationIcon, { class: "w-6 h-6 object-contain inline-block mr-2.5" }),
                                  _hoisted_18,
                                  (hasNotifications.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(MenuItem), null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: "flex items-center px-3 py-3 text-gray-600 transition bg-white cursor-pointer hover:bg-primary-300",
                                onClick: logoutUser
                              }, [
                                _createVNode(NavLogoutIcon, { class: "w-6 h-6 object-contain inline-block mr-2.5" }),
                                _hoisted_20
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      (__props.hasBack)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["bg-white lg:px-6 px-4 py-4 shadow-[0_1px_0px_0px_rgba(0,0,0,0.08)]", __props.hasBackClass])
          }, [
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (redirect()))
            }, [
              _createVNode(ButtonComponent, { customClass: "tertiary text-black hover:text-primary-600 transition lg:pl-4 pl-0 md:py-0 py-0" }, {
                default: _withCtx(() => [
                  _createVNode(ArrowLeftIcon, { class: "object-contain w-6 h-6 mr-2" }),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(__props.backTitle), 1)
                ]),
                _: 1
              })
            ]),
            _renderSlot(_ctx.$slots, "lowerMiddle"),
            _renderSlot(_ctx.$slots, "lowerRight")
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createVNode(_unref(TransitionRoot), {
          as: "template",
          show: showMenu.value
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Dialog), {
              as: "div",
              class: "relative z-10 hdr-menu",
              onClose: _cache[3] || (_cache[3] = ($event: any) => (showMenu.value = false))
            }, {
              default: _withCtx(() => [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_unref(TransitionChild), {
                        as: "template",
                        enter: "transform transition ease-in-out duration-300",
                        "enter-from": "translate-x-[-100%]",
                        "enter-to": "translate-x-0",
                        leave: "transform transition ease-in-out duration-300",
                        "leave-from": "translate-x-0",
                        "leave-to": "translate-x-[-100%]"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(DialogPanel), { class: "w-screen max-w-sm pointer-events-auto" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(XMarkIcon), {
                                class: "w-6 h-6 text-white absolute right-14 top-4 z-[1] cursor-pointer",
                                "aria-hidden": "true",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (showMenu.value = false))
                              }),
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, [
                                  _hoisted_28,
                                  _hoisted_29,
                                  _createElementVNode("div", _hoisted_30, [
                                    _createVNode(NavigationLink, {
                                      status: online.value,
                                      class: "flex-col"
                                    }, null, 8, ["status"])
                                  ])
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["show"])
      ]),
      _createVNode(SyncSplashModal),
      _createVNode(LockUserModal),
      _createVNode(NewPinModal),
      _createVNode(ConfirmationModal, {
        typeTwo: true,
        show: showConfirmation.value,
        onCancel: _cache[4] || (_cache[4] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[5] || (_cache[5] = ($event: any) => {triggerLogout(); showConfirmation.value = false}),
        "cancel-text": "Cancel",
        "action-text": "Logout",
        title: "Confirmation",
        content: "Are your sure you want to logout? Any Unsync Drafts will be deleted."
      }, null, 8, ["show"])
    ]),
    _: 3
  }))
}
}

})